import React from "react";
import { PageBanner, SectionTitle, ContactStrip, EnquiryForm } from "../components/Shared";
import { SCHOOL } from "../data/siteData";
import "./InnerPages.css";

const ContactPage = () => {
  return (
    <>
      <PageBanner title="Contact Us" breadcrumb="Contact" />

      {/* Contact Cards */}
      <section className="section">
        <div className="container">
          <SectionTitle title="Get In Touch" />
          <ContactStrip />
        </div>
      </section>

      {/* Enquiry Form */}
      <section className="section section--bg">
        <div className="container">
          <SectionTitle title="Send Us a Message" />
          <EnquiryForm />
        </div>
      </section>

      {/* Map */}
      <section className="section">
        <div className="container">
          <SectionTitle title="Our Location" />
          <div className="map-wrap card">
            <iframe
              src={SCHOOL.mapEmbed}
              width="100%"
              height="380"
              style={{ border: 0, display: "block", borderRadius: 8 }}
              allowFullScreen=""
              loading="lazy"
              title="IDPS Mahore Location"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
